module.exports = __webpack_public_path__ + "static/media/text-allign-right.2aaa4bee.svg";